import { createFileRoute, redirect } from '@tanstack/react-router'
import * as v from 'valibot'

import keycloak from '@/core/keycloak'

const validateSearch = v.object({
  idp_hint: v.optional(v.string()),
  redirect_uri: v.optional(v.string()),
  locale: v.optional(v.string()),
})

export const Route = createFileRoute('/login/')({
  validateSearch,
  beforeLoad: ({ search, buildLocation }) => {
    if (keycloak.authenticated) {
      if (search.redirect_uri) {
        throw redirect({ href: search.redirect_uri })
      }
      throw redirect({ to: '/home' })
    }
    const homeLocation = `${window.location.origin}${buildLocation({ to: '/home' }).href}`
    throw redirect({
      href: keycloak.createLoginUrl({
        redirectUri: search.redirect_uri || homeLocation,
        idpHint: search.idp_hint,
        locale: search.locale,
      }),
    })
  },
})
